export const AWS_S3_BUCKET = "data.mustard.love.upload";
export const AWS_S3_URL = `https://s3.amazonaws.com/${AWS_S3_BUCKET}/;`;
